{
  "(optional)": "(valinnainen)",
  "(required)": "(pakollinen)"
}